// @ts-nocheck

import { type StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { type BoomStepState } from '../../reducers/boom';
import { type BoomSteps } from '../../reducers/boom';
import { type BoomStepId } from '../../types/steps';
import { selectBoomState } from '../boom/boomPrimary.selector';

const emptyObj = {};

type SelectorPropsType = {
  stepId: BoomStepId;
};

export const selectBoomStepsState: Selector<BoomSteps> = (state: StateType) =>
  selectBoomState(state)?.steps ?? emptyObj;

export const selectBoomStepsEntity: Selector<BoomStepState> = (state: StateType, { stepId }: SelectorPropsType = {}) =>
  selectBoomStepsState(state)[stepId] ?? emptyObj;

export const selectBoomStepsEntityStepId: Selector<BoomStepId | undefined> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBoomStepsEntity(state, props).stepId;

export const selectBoomStepsEntityStakeMultiplier: Selector<number | null | undefined> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBoomStepsEntity(state, props).stakeMultiplier;

export const selectBoomStepsEntityEligibility: Selector<unknown> = (state: StateType, props: SelectorPropsType = {}) =>
  selectBoomStepsEntity(state, props).eligibility;
